import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOf } from '@cbridge-utils/redux-observable';
import { RoutingRuleAction } from '@cbridge-packages/routing-rules';
import { RulesManagementAction } from '@cbridge-modules/rules-management-page';

export const onUpdateRoutingRulesDoneEpic: IEpic = (action$) => action$.pipe(
  isTypeOf(
    RoutingRuleAction.update.done,
  ),
  mergeMap(() => {
    return [
      RulesManagementAction.endEditing(undefined),
    ];
  }),
);
